import { PaintedScene } from '../PaintedScene';

export const CARAVAN_ROAD_PHASER_KEY = 'CaravanRoadScene' as const;
export const CARAVAN_ROAD_MANIFEST_KEY = 's-208-caravan-road' as const;

export class CaravanRoadScene extends PaintedScene {
  constructor() {
    super(CARAVAN_ROAD_PHASER_KEY, CARAVAN_ROAD_MANIFEST_KEY);
  }
}
